import {Injectable} from "@angular/core";
import {OrderLocal} from "@app/core/my-order/domain/repository/order.local";
import {StorageLocal} from "@app/core/shared/domain/storage/storage.local";

@Injectable()
export class OrderLocalStorage implements OrderLocal{

    private LAST_ORDER_CODE_KEY = 'last-order-code'

    constructor(
        private localStorage: StorageLocal
    ) { }

    getLastOrderCode(): number | null {
        const orderCodeString = this.localStorage.getItem(this.LAST_ORDER_CODE_KEY);
        return orderCodeString != null ? parseInt(orderCodeString) : null;
    }

    setLastOrderCode(orderCode: number): void {
        this.localStorage.setItem(this.LAST_ORDER_CODE_KEY,orderCode.toString());
    }

}